export enum TaskStatus {
  unread = 'unread',
  read = 'read',
  completed = 'completed',
  pending = 'pending',
  isNotLive = 'isNotLive',
  escalated = 'escalated'
}

export const EXISTING_TASK_STATUSES = [
  TaskStatus.read,
  TaskStatus.unread,
  TaskStatus.pending,
  TaskStatus.escalated
];
